<template>
<div>
  <v-row no-gutters class="form-group">
    <span v-if="label !== ''" class="item-label">{{ label }}</span>
    <span v-else class="item-label" style="color:white" />
    <label class="form-group-label">
      <span v-if="required && !readonly" class="mandatory">必須</span>
    </label>
  </v-row>
  <v-autocomplete
    v-bind="computedProps"
    :placeholder="phtext"
    v-model="innerValue"
    v-on="computedListeners"
    label=""
    solo
    flat
    :tabindex="readonly ? -1 : 0"
    :search-input.sync="autocompleteText"
  >
    <template v-slot:append>
      <v-btn icon color="primary" dark elevation="0" small v-if="!readonly" @click.prevent.stop="teikeiCourseNoSync">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon color="primary" v-bind="attrs" @click.prevent.stop="teikeiCourseNoSync" @mousedown.prevent.stop="" @mouseup.prevent.stop="" v-on="on" tabindex="-1" dark elevation="0" small>
              <v-icon @click.prevent.stop="teikeiCourseNoSync">mdi-sync</v-icon>
            </v-btn>
          </template>
          <span>入力されている定型コースの情報を表示します<br>※押下後は取得した内容で上書きされます<br>&nbsp;&nbsp;編集中の情報は保存されません。</span>
        </v-tooltip>
      </v-btn>
      <v-btn icon color="primary" dark elevation="0" small v-if="!readonly" @click.prevent.stop="onDialogButtonClick">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon color="primary" v-bind="attrs" @click.prevent.stop="onDialogButtonClick" @mousedown.prevent.stop="" @mouseup.prevent.stop="" v-on="on" tabindex="-1" dark elevation="0" small>
              <v-icon>mdi-magnify-plus</v-icon>
            </v-btn>
          </template>
          <span>定型コース検索用ポップアップを表示します<br>※定型コース選択後は選択した内容で上書きされます<br>&nbsp;&nbsp;編集中の情報は保存されません。</span>
        </v-tooltip>
      </v-btn>
    </template>
  </v-autocomplete>

  <dd-package-teikei-course-search-dialog
    :showDialog="showDialog"
    :itemList="itemList"
    :param="teikeiCopyConditions"
    @close="onDialogClosed"/>
</div>
</template>
<script>
import controls from '@/rahmen/controls'
import validators from '@/rahmen/validators'
import inputMixin from '@/mixins/inputMixins'
import { VAutocomplete } from 'vuetify/lib'

const DdPackageTeikeiCourseSearchDialog = () => import('@/components/DdPackageTeikeiCourseSearchDialog')

export default {
  name: 'DdPackageTeikeiCourseSearchTextBox',
  extends: VAutocomplete,
  mixins: [inputMixin],
  components: {
    DdPackageTeikeiCourseSearchDialog
  },
  props: {
    /**
     * 入力タイプ
     * @see controls.InputTypes
     */
    valueType: Number,
    /**
     * 必須指定
     */
    required: Boolean,
    /**
     * 入力可能桁数
     */
    length: {
      type: Number,
      default: 999
    },
    /**
     * 表示エラーメッセージ
     */
    errorMessages: String,
    /**
     * 埋め込み文字
     */
    paddingChar: {
      type: String,
      default: ''
    },
    /**
     * コンプリートリスト
     */
    itemList: Array,
    /**
     * 返却値カラム名
     */
    returnValueName: {
      type: String,
      default: ''
    },
    /**
     *
     */
    code: String,
    /**
     * Dialog用ヘッダリスト
     * @see VDataTable
     */
    headerList: Array,
    /**
     * Dialog表示タイトル
     */
    titleText: String,
    /**
    * 絞り込み対象カラム
    */
    searchColumns: Array,
    /**
     * ラベル不要
     */
    noLabel: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    hasFocus: true,
    showDialog: false,
    invalidMessage: '',
    innerValue: {},
    autocompleteText: null,
    targetMaster: '',
    teikeiCopyConditions: {
      startHM: ''
    }
  }),
  created () {
  },
  mounted () {
    console.log('DdCodeTextBox.mounted', this.itemList, this.lazyValue)
    this.innerValue = this.lazyValue
    this.invalidMessage = this.errorMessages
    console.log('mounted', this.invalidMessage)

    if (this.invalidMessage === undefined) {
      // this[controls.VALIDATE_METHOD]()
    }
    // create targetMaster
    this.targetMaster = this.itemValue.replace('Cd', '')
  },
  watch: {
    itemList: function (newlist, oldlist) {
      console.log(newlist)
      this.itemList = newlist
    },
    value (n, o) {
      console.log('dd-code-text-box.watch(value)', o, n)
      if (o === n || n === undefined) { return }
      this.innerValue = n
      this.$emit('input', this.innerValue)
    },
    autocompleteText (value) {
      if (value === '') {
        this.innerValue = null
        this.$emit('input', this.innerValue)
      }
    }
  },
  computed: {
    phtext () {
      return !this.readonly ? 'コードまたは名称で検索' : ' '
    },
    computedProps () {
      return {
        ...this.$props,
        maxlength: this.length,
        class: this.readonly ? ' readonly-item' : this.required ? ' required-item' : this.class,
        hideDetails: 'auto',
        items: this.filteredItems,
        itemValue: this.itemValueName,
        itemText: 'text',
        clearable: false,
        clearIcon: '',
        dense: true,
        error: this.hasError,
        errorMessages: this.invalidMessage,
        filter: this.suggestFillter
      }
    },
    itemValueName () {
      return this.returnValueName === '' ? this.itemValue : this.returnValueName
    },
    computedListeners () {
      return {
        ...this.$listeners,
        blur: e => this.onBlur(e),
        focus: e => this.onFocus(e)
      }
    },
    hasError () {
      return this.invalidMessage !== '' && this.invalidMessage !== undefined
    },
    filteredItems () {
      if (this.itemList === undefined) { return [] }
      return this.itemList.map(e => {
        const result = {
          ...e,
          value: e[this.itemValueName],
          text: `${e[this.itemValue]} : ${e[this.itemText]}`
        }
        return result
      })
    }
  },
  methods: {
    onBlur: function (e) {
      console.log('DdCodeTextBox.onBlur', e)
      this[controls.VALIDATE_METHOD]()
      if (!this.hasError) {
        this[controls.FORMAT_METHOD]()
      }
    },
    onFocus: function (e) {
    },
    onInput: function (e) {
      console.log('DdCodeTextBox.onInput', e, e.target.value)
      const elem = this.$el.querySelector('input')
      if (elem) { elem.select() }

      const val = e.target.value
      if (val === '') {
        this.value = { value: '' }
      }
    },
    onDialogButtonClick: function (e) {
      this.showDialog = true
      console.log('dialog opend', e)
    },
    onDialogClosed: function (e) {
      this.showDialog = false
      if (e === undefined) { return }
      this.innerValue = e.teikeiCourseNo

      /**
       * dialog選択値inputイベント
       * @event input
       * @type {Event}
       */
      this.$emit('input', this.innerValue)
      this[controls.VALIDATE_METHOD]()
      this.teikeiCourseNoDialogSync(e)
    },
    /**
     * dialog選択時イベント
     * @event input
     * @type {Event}
     * this.$emit('input', this.innerValue)
     */
    teikeiCourseNoDialogSync: function (e) {
      this.$emit('teikeiCourseNoDialogSync', e)
    },
    /**
     * 反映ボタン押下時イベント
     * @event input
     * @type {Event}
     * this.$emit('input', this.innerValue)
     */
    teikeiCourseNoSync: function (e) {
      this.$emit('teikeiCourseNoSync', e)
    },
    suggestFillter: function (item, queryText, itemText) {
      console.log('suggestFillter', item, queryText, itemText)
      const keys = !this.searchColumns ? ['teikeiCourseNo', 'teikeiCourseNm'] : this.searchColumns
      for (let i = 0; i < keys.length; i++) {
        const v = String(item[keys[i]])
        if (keys[i].indexOf('No') !== -1) {
          if (v === queryText) { return true }
        } else {
          if (v.indexOf(queryText) !== -1) { return true }
        }
      }
      return false
    },
    [controls.VALIDATE_METHOD]: function () {
      const target = {
        value: this.innerValue,
        length: this.length
      }
      console.log(this)
      this.invalidMessage = undefined
      const validatorList = controls.getInputTypeValidators(this.valueType)

      if (this.required) { validatorList.unshift(validators.requireValidate) }
      if (this.appendValidators) { validatorList.push(...this.appendValidators) }

      for (let i = 0; i < validatorList.length; i++) {
        const f = validatorList[i]
        const ret = f(target)
        console.log(target, f.name, ret)
        if (ret !== undefined) {
          this.invalidMessage = ret
          return
        }
      }
    },
    [controls.FORMAT_METHOD]: function () {
    }
  }
}

</script>
<style scoped>
</style>
